import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetPendingPaymentsParams {
  startDate: string;
  endDate: string;
}

export interface PendingPayment {
  date: string;
  pending: number;
}

export const getPendingPayments = async (params: GetPendingPaymentsParams) => {
  const response = await baseAPI.get<Array<PendingPayment>>(
    `subscription-invoices/pending-payment-history`,
    {
      params: {
        ...params,
      },
    },
  );
  return response.data;
};

export const useGetPendingPayments = (params: GetPendingPaymentsParams) => {
  return useQuery({
    queryKey: [KEYS.PENDING_PAYMENTS, params.startDate, params.endDate],
    queryFn: () => getPendingPayments(params),
    // staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
